export type Sorting = {
  sortBy: string
  sortingOrder: 'asc' | 'desc'
}

export const defaultSorting: Sorting = {
  sortBy: 'name',
  sortingOrder: 'desc',
}
